module.exports = __webpack_public_path__ + "img/cone_pt_rnd_setsku.prt.9da65d15.jpg";